export default __webpack_public_path__ + "static/media/websiteBlack.e27e099a.svg";